module.exports = __webpack_public_path__ + "img/wz-8-6-4.f2df8c33.jpg";